
import React from 'react';
import AnimatedSection from '../../../components/base/AnimatedSection';

const ServicesSection = () => {
  return (
    <AnimatedSection className="py-20 px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-[#394851] mb-6">
            Project Packages (Pay Once, Own Forever)
          </h2>
          <p className="text-xl text-[#748881] max-w-3xl mx-auto leading-relaxed">
            Start with a project. Prove ourselves. Build trust. No long-term commitments—just results you can see and copy you can use everywhere.
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-8 mb-16">
          {/* Takeoff Package */}
          <div className="bg-gradient-to-br from-[#A8AE9C]/10 to-[#748881]/10 rounded-lg p-8 border border-[#A8AE9C]/30 relative">
            <div className="text-center mb-6">
              <h3 className="text-2xl font-bold text-[#394851] mb-2">Takeoff</h3>
              <div className="text-4xl font-bold text-[#748881] mb-2">$750</div>
              <p className="text-[#748881] font-medium">7-10 business days</p>
            </div>
            
            <div className="space-y-3 mb-8">
              <div className="flex items-start space-x-3">
                <i className="ri-check-line text-[#A8AE9C] mt-1"></i>
                <span className="text-[#748881] text-sm">Homepage (500 words)</span>
              </div>
              <div className="flex items-start space-x-3">
                <i className="ri-check-line text-[#A8AE9C] mt-1"></i>
                <span className="text-[#748881] text-sm">About page (400 words)</span>
              </div>
              <div className="flex items-start space-x-3">
                <i className="ri-check-line text-[#A8AE9C] mt-1"></i>
                <span className="text-[#748881] text-sm">1 service page (400 words)</span>
              </div>
              <div className="flex items-start space-x-3">
                <i className="ri-check-line text-[#A8AE9C] mt-1"></i>
                <span className="text-[#748881] text-sm">1 welcome email</span>
              </div>
              <div className="flex items-start space-x-3">
                <i className="ri-check-line text-[#A8AE9C] mt-1"></i>
                <span className="text-[#748881] text-sm">2 revision rounds</span>
              </div>
            </div>
            
            <div className="bg-[#394851]/5 rounded-lg p-4 mb-6">
              <p className="text-[#748881] text-xs font-medium">
                Payment: Full payment upfront
              </p>
            </div>
            
            <button className="w-full bg-[#394851] text-white py-3 rounded-lg font-semibold hover:bg-[#748881] transition-colors cursor-pointer whitespace-nowrap">
              Start with Takeoff
            </button>
          </div>

          {/* Flight Path Package */}
          <div className="bg-gradient-to-br from-[#394851] to-[#748881] text-white rounded-lg p-8 relative transform scale-105 shadow-xl">
            <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
              <span className="bg-[#A8AE9C] text-[#394851] px-4 py-1 rounded-full text-sm font-semibold">
                Most Popular
              </span>
            </div>
            
            <div className="text-center mb-6">
              <h3 className="text-2xl font-bold mb-2">Flight Path</h3>
              <div className="text-4xl font-bold text-[#A8AE9C] mb-2">$1,850</div>
              <p className="text-gray-200 font-medium">14-21 business days</p>
            </div>
            
            <div className="space-y-3 mb-8">
              <div className="flex items-start space-x-3">
                <i className="ri-check-line text-[#A8AE9C] mt-1"></i>
                <span className="text-sm">Homepage (600 words)</span>
              </div>
              <div className="flex items-start space-x-3">
                <i className="ri-check-line text-[#A8AE9C] mt-1"></i>
                <span className="text-sm">About page (500 words)</span>
              </div>
              <div className="flex items-start space-x-3">
                <i className="ri-check-line text-[#A8AE9C] mt-1"></i>
                <span className="text-sm">3 service pages (400 words each)</span>
              </div>
              <div className="flex items-start space-x-3">
                <i className="ri-check-line text-[#A8AE9C] mt-1"></i>
                <span className="text-sm">5-email welcome sequence</span>
              </div>
              <div className="flex items-start space-x-3">
                <i className="ri-check-line text-[#A8AE9C] mt-1"></i>
                <span className="text-sm">2 social media ad copies</span>
              </div>
              <div className="flex items-start space-x-3">
                <i className="ri-check-line text-[#A8AE9C] mt-1"></i>
                <span className="text-sm">SEO keyword research</span>
              </div>
              <div className="flex items-start space-x-3">
                <i className="ri-check-line text-[#A8AE9C] mt-1"></i>
                <span className="text-sm">3 revision rounds</span>
              </div>
            </div>
            
            <div className="bg-white/10 rounded-lg p-4 mb-6">
              <p className="text-gray-200 text-xs font-medium">
                Payment: 50% deposit to start, 50% upon delivery
              </p>
            </div>
            
            <button className="w-full bg-[#A8AE9C] text-[#394851] py-3 rounded-lg font-semibold hover:bg-white transition-colors cursor-pointer whitespace-nowrap">
              Choose Flight Path
            </button>
          </div>

          {/* First Class Package */}
          <div className="bg-gradient-to-br from-[#A8AE9C]/10 to-[#748881]/10 rounded-lg p-8 border border-[#A8AE9C]/30 relative">
            <div className="text-center mb-6">
              <h3 className="text-2xl font-bold text-[#394851] mb-2">First Class</h3>
              <div className="text-4xl font-bold text-[#748881] mb-2">$4,500</div>
              <p className="text-[#748881] font-medium">21-30 business days</p>
            </div>
            
            <div className="space-y-3 mb-8">
              <div className="flex items-start space-x-3">
                <i className="ri-check-line text-[#A8AE9C] mt-1"></i>
                <span className="text-[#748881] text-sm">Full website copy (6-8 pages, ~4,000 words)</span>
              </div>
              <div className="flex items-start space-x-3">
                <i className="ri-check-line text-[#A8AE9C] mt-1"></i>
                <span className="text-[#748881] text-sm">7-email nurture sequence</span>
              </div>
              <div className="flex items-start space-x-3">
                <i className="ri-check-line text-[#A8AE9C] mt-1"></i>
                <span className="text-[#748881] text-sm">4 social media ad variations</span>
              </div>
              <div className="flex items-start space-x-3">
                <i className="ri-check-line text-[#A8AE9C] mt-1"></i>
                <span className="text-[#748881] text-sm">1 landing page (800 words)</span>
              </div>
              <div className="flex items-start space-x-3">
                <i className="ri-check-line text-[#A8AE9C] mt-1"></i>
                <span className="text-[#748881] text-sm">Brand messaging guide</span>
              </div>
              <div className="flex items-start space-x-3">
                <i className="ri-check-line text-[#A8AE9C] mt-1"></i>
                <span className="text-[#748881] text-sm">Strategic consultation call</span>
              </div>
              <div className="flex items-start space-x-3">
                <i className="ri-check-line text-[#A8AE9C] mt-1"></i>
                <span className="text-[#748881] text-sm">Priority support (48-hour response)</span>
              </div>
              <div className="flex items-start space-x-3">
                <i className="ri-check-line text-[#A8AE9C] mt-1"></i>
                <span className="text-[#748881] text-sm">Unlimited revisions within 30 days</span>
              </div>
            </div>
            
            <div className="bg-[#394851]/5 rounded-lg p-4 mb-6">
              <p className="text-[#748881] text-xs font-medium">
                Payment: 50% deposit to start, 50% upon delivery
              </p>
            </div>
            
            <button className="w-full bg-[#394851] text-white py-3 rounded-lg font-semibold hover:bg-[#748881] transition-colors cursor-pointer whitespace-nowrap">
              Discuss First Class
            </button>
          </div>
        </div>

        {/* Add-Ons Section */}
        <div className="bg-[#748881]/5 rounded-lg p-8 mb-12">
          <h3 className="text-2xl font-bold text-[#394851] mb-6 text-center">Add-Ons Available</h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            <div className="bg-white p-4 rounded-lg border border-[#A8AE9C]/30">
              <h4 className="font-semibold text-[#394851] mb-2">Extra web page</h4>
              <p className="text-[#748881] text-2xl font-bold">$200</p>
            </div>
            <div className="bg-white p-4 rounded-lg border border-[#A8AE9C]/30">
              <h4 className="font-semibold text-[#394851] mb-2">Extra email</h4>
              <p className="text-[#748881] text-2xl font-bold">$150</p>
            </div>
            <div className="bg-white p-4 rounded-lg border border-[#A8AE9C]/30">
              <h4 className="font-semibold text-[#394851] mb-2">Blog post</h4>
              <p className="text-[#748881] text-lg font-bold">$250-350</p>
              <p className="text-[#748881] text-sm">(800-1,000 words)</p>
            </div>
            <div className="bg-white p-4 rounded-lg border border-[#A8AE9C]/30">
              <h4 className="font-semibold text-[#394851] mb-2">Case study</h4>
              <p className="text-[#748881] text-lg font-bold">$400-600</p>
            </div>
            <div className="bg-white p-4 rounded-lg border border-[#A8AE9C]/30">
              <h4 className="font-semibold text-[#394851] mb-2">Rush delivery</h4>
              <p className="text-[#748881] text-lg font-bold">+50%</p>
              <p className="text-[#748881] text-sm">Cuts timeline in half</p>
            </div>
            <div className="bg-white p-4 rounded-lg border border-[#A8AE9C]/30">
              <h4 className="font-semibold text-[#394851] mb-2">Confidentiality</h4>
              <p className="text-[#748881] text-lg font-bold">+$250</p>
              <p className="text-[#748881] text-sm">For sensitive industries</p>
            </div>
          </div>
        </div>

        {/* Ready to Go Further Section */}
        <div className="bg-[#394851] text-white rounded-lg p-12">
          <div className="max-w-4xl mx-auto text-center">
            <h3 className="text-3xl font-semibold mb-6 text-[#A8AE9C]">
              Ready to Go Further?
            </h3>
            
            <p className="text-lg text-gray-200 mb-8 leading-relaxed">
              After your project, if you want ongoing support—whether it's monthly content, campaign launches, or continuous optimization—let's talk. We'll discuss what growth looks like for your business over a strategy call.
            </p>
            
            <div className="bg-[#A8AE9C]/20 rounded-lg p-8">
              <h4 className="text-2xl font-semibold mb-4 text-[#A8AE9C]">Retainer Partnerships Available</h4>
              <p className="text-lg text-gray-200 mb-6 leading-relaxed">
                Ongoing optimization, strategic guidance, and continuous growth partnerships. 
                Pricing and details discussed privately based on your specific needs and goals.
              </p>
              <p className="text-lg italic text-[#A8AE9C]">
                "This is about building a covenant, not a contract. You stay because you want to, not because you have to."
              </p>
            </div>
          </div>
        </div>
      </div>
    </AnimatedSection>
  );
};

export default ServicesSection;
